// extracted by mini-css-extract-plugin
export default {"main":"Business_main__lJgh0","contents_wrap":"Business_contents_wrap__pP3oR","clients_title":"Business_clients_title__qQCyA","img_wrap":"Business_img_wrap__mi-Xo"};